import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const CarLanding = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [query, setQuery] = useState('');
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data.filter(e => e.car?.title?.toLowerCase()?.includes(query.toLowerCase()))?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')){
      dispatch(setLoading(true));
      
      const res = await restApi(endpoints.landing.carLanding + id).delete({});
      
      if(res.code == 200){
        Swal.fire({
          title: 'موفق',
          text: 'لندینگ با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }
      
      dispatch(setLoading(false));
    }
  }
  const list = () => {
    const rows = [];

    currentItems.map((category: any, index) => {
      rows.push(
        <tr className="">
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem(category.id) }></i>
            <i className="edit clickable" onClick={() => navigate("/carLanding/edit/" + category.id)}></i>
          </td>
          <td className="">{category.createdAt}</td>
          <td className="">{category.landing.description}</td>
          <td className="">{category.landing.slug}</td>
          <td className="">{category.car.title}</td>
          <td className="">{category.category.title}</td>
          <td>{++index}</td>
        </tr>
      )
    })
    
    return rows;
  };
  
  const fetchData = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.landing.carLanding).get();
    if(res.code == 200){
      setData(res.data);
    }
    
    dispatch(setLoading(false));
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  
  return(
    
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست لندینگ ها</h1>
        <div className="searchContainer">
          <span className="dashboardHeader clickable"  onClick={() => navigate('/carLanding/add')}>
            <p>افزودن لندینگ جدید</p>
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input:any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="listTable">
          <thead>
          <tr className="firstTr">
            <th>عملیات</th>
            <th>تاریخ ساخت</th>
            <th>توضیحات</th>
            <th>اسلاگ</th>
            <th>ماشین</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
        <ReactPaginate
          breakLabel="..."
          nextLabel="بعدی >"
          onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< قبلی"
          renderOnZeroPageCount={null}
          className="pagination"
          pageClassName="paginationBreak"
          previousClassName="paginationBreak"
          nextClassName="paginationBreak"
          activeClassName="paginationActive"
        />
      </main>
      </body>
    </>
  )
}
export default CarLanding;